export default __webpack_public_path__ + "static/media/profile1.112b1892.png";